module.exports = __webpack_public_path__ + "media/images/app-day-5515f4a053d51b3ae0295a393b1851d0.png";